import { Link } from 'react-router-dom';
import Tracks from '../components/Tracks';
import '../css/services.scss'
import Box from '@mui/material/Box';

// import '../css/tooltip.scss';

const Services = () => {
  return (
    <Box id="services">
      <div id="title">
        <h1>CHAUFFEUR PRIVE A CHARLEROI</h1>
      </div>
      <Box className="jumbo"
      sx={(theme) => ({
        backgroundColor: theme.palette.mode === 'dark' ? '#6F6F6F' : '#EFEFEF',
        color: '#CA8E4C',
      })}>
        <h2 className="content-width">Koffi Transports vous propose des transports en navette dans toute la Belgique et les pays aux alentours.</h2>
      </Box>
      <Tracks />
      <Link to="/contact" className="booknow">
        <img id="scheduling-17983227" src="images/rdv.png" alt="Bouton réservez maintenant" />
      </Link>
    </Box>
  )
};

export default Services;
